"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CurrencyCodes = require("self-service-api/constants/CurrencyCodes");

// A mapping of countries to official currencies, to predict best default activeCurrencyCode for a user.
var _default = {
  'isle of man': _CurrencyCodes.GBP,
  'reunion island': _CurrencyCodes.EUR,
  'san marino': _CurrencyCodes.EUR,
  'slovak republic': _CurrencyCodes.EUR,
  'united kingdom': _CurrencyCodes.GBP,
  andorra: _CurrencyCodes.EUR,
  australia: _CurrencyCodes.AUD,
  austria: _CurrencyCodes.EUR,
  bulgaria: _CurrencyCodes.EUR,
  belgium: _CurrencyCodes.EUR,
  colombia: _CurrencyCodes.COP,
  czechia: _CurrencyCodes.EUR,
  cyprus: _CurrencyCodes.EUR,
  denmark: _CurrencyCodes.EUR,
  estonia: _CurrencyCodes.EUR,
  finland: _CurrencyCodes.EUR,
  france: _CurrencyCodes.EUR,
  germany: _CurrencyCodes.EUR,
  gibraltar: _CurrencyCodes.GBP,
  greece: _CurrencyCodes.EUR,
  hungary: _CurrencyCodes.EUR,
  ireland: _CurrencyCodes.EUR,
  italy: _CurrencyCodes.EUR,
  japan: _CurrencyCodes.JPY,
  jersey: _CurrencyCodes.GBP,
  latvia: _CurrencyCodes.EUR,
  lithuania: _CurrencyCodes.EUR,
  luxembourg: _CurrencyCodes.EUR,
  malta: _CurrencyCodes.EUR,
  monaco: _CurrencyCodes.EUR,
  netherlands: _CurrencyCodes.EUR,
  norway: _CurrencyCodes.EUR,
  poland: _CurrencyCodes.EUR,
  portugal: _CurrencyCodes.EUR,
  romania: _CurrencyCodes.EUR,
  singapore: _CurrencyCodes.SGD,
  slovakia: _CurrencyCodes.EUR,
  slovenia: _CurrencyCodes.EUR,
  spain: _CurrencyCodes.EUR,
  sweden: _CurrencyCodes.EUR
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/CountryToCurrency.js
// module id = 889
// module chunks = 5 6